import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { accountService } from "../../_services/accounts.service";
import { userInformationService } from "../../_services/userInformation.service";
import { GenderEnum } from "../../_common/enum/gender.enum";
import { stringToDateFormat } from "../../_helpers/format.helper";
import moment from "moment";
import { RacingClubAutoComplete } from "../../_components/autocomplete/racingClub.autoComplete";

export function UserInfoManage() {

    const { userId } = useParams<{ userId: string }>();

    let navigate = useNavigate();

    const resetData = () => ({
        id: "",
        firstName: '',
        lastName: '',
        name: '',
        email: '',
        phone: '',
        country: '',
        address: '',
        county: '',
        postalCode: '',
        username: '',
        gardaVettingExpiryDate: '',
        genderId: '',
        userId: userId
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isMergeOpen, setIsMergeOpen] = useState(false);
    const [data, setData] = useState<any>(resetData);
    const [userGuid, setUserGuid] = useState("");

    useEffect(() => {
        fetchData(userId || accountService.currentUserValue.id);
    }, []);

    function fetchData(id: string) {

        setIsLoading(true)
        return userInformationService
            .getInformation(id)
            .then(
                (json) => {

                    if (json.dateOfBirth)
                        json.dateOfBirth = moment(json.dateOfBirth).format('YYYY-MM-DD');

                    if (json.gardaVettingExpiryDate)
                        json.gardaVettingExpiryDate = moment(json.gardaVettingExpiryDate).format('YYYY-MM-DD');

                    if (json.medicalExpiry)
                        json.medicalExpiry = moment(json.medicalExpiry).format('YYYY-MM-DD');

                    if (json.ecgCardiologistExpiry)
                        json.ecgCardiologistExpiry = moment(json.ecgCardiologistExpiry).format('YYYY-MM-DD');

                    if (json.firstRacingLicenseDate)
                        json.firstRacingLicenseDate = moment(json.firstRacingLicenseDate).format('YYYY-MM-DD');

                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function handleChange(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: event.target.value } });
    };

    function submit() {
        setIsLoading(true);
        setIsSaving(true);
        return userInformationService
            .updateInformation({ ...data, userId: userId })
            .then(
                (json) => {
                    //setData(json);
                    toastr.success("Saved successfully");
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
                setIsSaving(false)
            });
    }

    function mergeAccounts() {
        setIsLoading(true);
        setIsSaving(true);
        return userInformationService
            .merge({ fromUserId: userGuid, toUserId: userId })
            .then(
                (json) => {
                    //setData(json);
                    toastr.success("Merged successfully");
                    navigate(0);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
                setIsSaving(false)
            });
    }

    function handleDateChange(event: any) {
        setData((__data: any) => {
            return { ...__data, [event.target.name]: stringToDateFormat(event.target.value) }
        });
    };

    return (
        <>

            {accountService.isAdmin &&
                <>
                    <Grid item xs={12}>
                        <PrimaryButton
                            type="button"
                            variant="success"
                            onClick={() => { setIsMergeOpen(true) }}
                            disabled={isLoading || isSaving}>

                            Merge With Another Account
                        </PrimaryButton>
                    </Grid>

                    <Dialog
                        open={isMergeOpen}
                        onClose={() => { setIsMergeOpen(false) }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">

                        <DialogTitle id="alert-dialog-title">
                            {"Merging of accounts"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Merging of accounts will update all user links from provided user's GUID to the current user's GUID.
                            </DialogContentText>
                            <DialogContentText id="alert-dialog-description2">
                                <br />
                                <ValidatorForm
                                    onSubmit={() => { }}
                                    noValidate>

                                    <Grid item xs={12} >
                                        <TextValidatorHcs
                                            key="userGuid"
                                            name="userGuid"
                                            label="User Guid"
                                            fullWidth
                                            required
                                            disabeled={!accountService.isAdmin}
                                            value={userGuid}
                                            onChange={(event: any) => { setUserGuid(event.target.value) }}
                                        />
                                    </Grid>

                                </ValidatorForm>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button disabled={isSaving} onClick={() => { setIsMergeOpen(false) }}>Disagree</Button>
                            <Button disabled={isSaving} onClick={() => { mergeAccounts() }} autoFocus>
                                Agree
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            }
            
            <ValidatorForm
                onSubmit={() => { }}
                noValidate>

                <Grid container spacing={2} sx={{ mt: 0 }}>

                    <Grid item xs={12}>
                        <Typography variant="h6" textAlign="center">User Information</Typography>
                    </Grid>


                    <Grid item xs={12} >
                        <TextValidatorHcs
                            key="firstName"
                            name="firstName"
                            label="Name"
                            fullWidth
                            disabeled={!accountService.isAdmin}
                            value={data.firstName}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextValidatorHcs
                            key="lastName"
                            name="lastName"
                            label="Surname"
                            fullWidth
                            disabeled={!accountService.isAdmin}
                            value={data.lastName}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextValidatorHcs
                            type="date"
                            key="dateOfBirth"
                            name="dateOfBirth"
                            label="Date of Birth"
                            fullWidth
                            value={data.dateOfBirth}
                            onChange={handleDateChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextValidatorHcs
                            key="nationality"
                            name="nationality"
                            label="Nationality"
                            fullWidth
                            value={data.nationality}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel shrink={!!data.genderId}>Gender</InputLabel>
                            <Select notched
                                value={data.genderId}
                                label="Gender"
                                name="genderId"
                                onChange={handleChange}
                            >
                                <MenuItem value={GenderEnum.Female}>Female</MenuItem>
                                <MenuItem value={GenderEnum.Male}>Male</MenuItem>
                                <MenuItem value={GenderEnum.None}>None</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextValidatorHcs
                            key="phone"
                            name="phone"
                            label="Mobile Phone"
                            fullWidth
                            value={data.phone}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextValidatorHcs
                            type="email"
                            key="Email"
                            name="email"
                            label="Email"
                            fullWidth
                            value={data.email}
                            helperText={"To update email, please contact the Motorsport Ireland staff"}
                            readonly
                            disabled
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextValidatorHcs
                            type="date"
                            key="gardaVettingExpiryDate"
                            name="gardaVettingExpiryDate"
                            label="Garda Vetting Expiry Date"
                            fullWidth
                            disabled={!accountService.isAdmin}
                            value={data.gardaVettingExpiryDate}
                            onChange={handleDateChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextValidatorHcs
                            type="date"
                            key="ecgCardiologistExpiry"
                            name="ecgCardiologistExpiry"
                            label="ECG CardiologistExpiry"
                            fullWidth
                            disabled={!accountService.isAdmin}
                            value={data.ecgCardiologistExpiry}
                            onChange={handleDateChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextValidatorHcs
                            type="date"
                            key="medicalExpiry"
                            name="medicalExpiry"
                            label="Medical Expiry"
                            fullWidth
                            disabled={!accountService.isAdmin}
                            value={data.medicalExpiry}
                            onChange={handleDateChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>

                        <RacingClubAutoComplete
                            isRequired
                            itemId={data.racingClubId}
                            disabled={!accountService.isAdmin}
                            name={"racingClubId"}
                            variant="outlined"
                            onItemChange={handleChange} />
                    </Grid>

                    {accountService.isAdmin &&
                        <Grid item xs={12} sm={6}>
                            <TextValidatorHcs
                                type="date"
                                key="firstRacingLicenseDate"
                                name="firstRacingLicenseDate"
                                label="First Racing Licence Date"
                                fullWidth
                                disabled={true}
                                value={data.firstRacingLicenseDate}
                                onChange={handleDateChange}
                            />
                        </Grid>
                    }

                    <Grid item xs={12}>

                        <PrimaryButton
                            type="button"
                            variant="success"
                            onClick={submit}
                            disabled={isLoading || isSaving}>

                            Update User Information
                        </PrimaryButton>
                    </Grid>


                </Grid>

            </ValidatorForm >
        </>
    );

}
